import React, { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../app/utils/hooks/reduxHook'
import { getUserData } from '../../../redux/API/UserAPI';
import Sidebar from '../../template/Sidebar';
import './Dashboard.scss';
import Navbar from '../../template/Navbar';
import { checkPermission, permissionType } from '../../../app/utils/common/checkPermission';
import Loader from '../../atoms/Loader/Loader';
import { getUnseenNotificationAPI } from '../../../redux/API/NotificationAPI';
import { PaginationType } from '../../../dto/Pagination.dto';
import { SetNotificationPagination, SetUnseenNotificationCount } from '../../../redux/Slices/notificationSlice';
import { getPostRequestsAPI } from '../../../redux/API/PostAPI';
import { setPendingPostsCount } from '../../../redux/Slices/postSlice';
import { sidebarOptions } from '../../../dto/SidebarOptions';
import { getRegistrationRequestsAPI } from '../../../redux/API/RegistrationRequestAPI';
import { setRegistrationReqCount } from '../../../redux/Slices/registrationRequestSlice';
import { getDashboardAPI } from '../../../redux/API/DashboardAPI';
import { SetDashboardData } from '../../../redux/Slices/dashboardSlice';
const Dashboard = () => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, user, loading, access_token } = useAppSelector(state => state.auth);
  const { pagination } = useAppSelector((state) => state.notification)
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    if (!isAuthenticated && !user) {
      if (localStorage.getItem('access_token') || access_token) {
        dispatch(getUserData())
      } else {
        navigate('/login');
      }
    }
  }, [dispatch, isAuthenticated, user])

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getUnseenNotificationAPI({ page: 1 }))
    }
  }, [dispatch, isAuthenticated])


  //to get pending posts count
  // useEffect(() => {
  //   if (checkPermission(permissionType.POST_MODULE, "read")) {
  //     dispatch(getPostRequestsAPI({ current_page: 1, Post_Status: "pending" })).unwrap().then((result) => {
  //       dispatch(setPendingPostsCount(result?.pagination?.total_data))
  //     })
  //   }
  // }, [dispatch])

  // //to get registration request count
  // useEffect(() => {
  //   if (checkPermission(permissionType.USER_REGISTRATION_REQUEST, "read")) {
  //     dispatch(getRegistrationRequestsAPI({ page: 1, registration_req_Status: "pending", })).unwrap().then((result) => {
  //       dispatch(setRegistrationReqCount(result?.pagination?.total_data))
  //     })
  //   }
  // }, [dispatch])

  //to get all dashboard data - all counts
  useEffect(() => {
    dispatch(getDashboardAPI()).unwrap().then((result) => {
        dispatch(SetDashboardData(result))})
      .catch((err) => {
        console.error("Error fetching dashboard data: ", err);
      });
  }, [dispatch]);
    
  useEffect(() => {
    if (isAuthenticated && user) {
      const pathParts = path.split('/').filter(Boolean);
      let key = pathParts.length > 0 && pathParts[1] ? pathParts[1] : "/";
      console.log("🚀 ~ useEffect ~ key:", key)
      switch (key) {
        case "site-management":
          if (!checkPermission(permissionType.SITE_MODULE, "read")) {
            navigate("/not-found");
          }
          return;
        case "manage-manager":
          if (!checkPermission(permissionType.MANAGER_MODULE, "read")) {
            navigate("/not-found");
          }
          return;
        case "manage-broker":
          if (!checkPermission(permissionType.BROKER_MODULE, "read")) {
            navigate("/not-found");
          }
          return;
        case "manage-group":
          if (!checkPermission(permissionType.GROUP_MODULE, "read")) {
            navigate("/not-found");
          }
          return;
        case "post-requests":
          if (!checkPermission(permissionType.POST_MODULE, "read")) {
            navigate("/not-found");
          }
          return;
        case "registration-request":
          if (!checkPermission(permissionType.USER_REGISTRATION_REQUEST, "read")) {
            navigate("/not-found");
          }
          return;
        case "all-users":
          if (!checkPermission(permissionType.USER_MODULE, "read")) {
            navigate("/not-found");
          }
          return;
        case "visit-management":
          if (!checkPermission(permissionType.VISIT_MODULE, "read")) {
            navigate("/not-found");
          }
          return;
        case "/":
          if (checkPermission(permissionType.DASHBOARD_MODULE, "read")) {
            return;
          } else {
            if (checkPermission(permissionType.USER_MODULE, "read")) {
              navigate("/dashboard/all-users")
            }
            else if (checkPermission(permissionType.VISIT_MODULE, "read")) {
              navigate("/dashboard/visit-management")
            } else if (checkPermission(permissionType.POST_MODULE, "read")) {
              navigate("/dashboard/post-requests");
            } else if (checkPermission(permissionType.USER_REGISTRATION_REQUEST, "read")) {
              navigate("/dashboard/registration-request");
            }
          }
          return;
        default:
          return;
      }
    }
  }, [isAuthenticated, user, path])

  return (
    <div className='dashboard-container'>
      {loading ? <div className='loading-container'><Loader /> </div> :

        <>
          <Sidebar />
          <div className='dashboard-outlet-container'>
            <div className='navbar'>
              <Navbar />
            </div>
            <div className='outlet'>
              <Outlet />
            </div>
          </div>
        </>
      }
    </div>
  )
}

export default Dashboard